import _util from '../../utils/';

const dailyReportrexceptionDtatisticsService = {

	fetchHRWorkReportExceptionStatisticsList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportExceptionStatistics/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	exportNoDeliveryDailyReportList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportExceptionStatistics/dailyExport',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	fetchNoDeliveryDailyReportList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportExceptionStatistics/NoDeliveryDailyReport',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	exportNoDeliveryWeeklyReportList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportExceptionStatistics/weeklyExport',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	fetchNoDeliveryWeeklyReportList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportExceptionStatistics/NoDeliveryWeeklyReport',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	updateHRWorkReportExceptionStatistics(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportExceptionStatistics/Put',
			method: 'put',
			data: puts,
			success: resolve,
			 error: reject  
		})
	},
	deleteHRWorkReportExceptionStatistics(data, resolve, reject) {
        _util.request({
            url: '/api/HRWorkReportExceptionStatistics/BatchDelete',
            method: "delete",
            data: data,
            success: resolve,
            error: reject
        });  
    },
}

export default dailyReportrexceptionDtatisticsService




// WEBPACK FOOTER //
// ./src/services/WorkReport/daily-reportrexception-statistics-service.js